import { createActions, createReducer } from 'reduxsauce'

import PortalService from '../servicos/PortalService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaMenuInicio: [],
    buscaMenuSucesso: ['menu'],
    buscaMenuErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaMenu = () => {
    return dispatch => {
        dispatch(Creators.buscaMenuInicio())
        let serv = new PortalService()
        return serv
            .getMenu()
            .then(response => dispatch(Creators.buscaMenuSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaMenuErro(error)))
    }
}

const buscaMenuInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaMenuErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaMenuSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.menu, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_MENU_INICIO]: buscaMenuInicio,
    [Types.BUSCA_MENU_ERRO]: buscaMenuErro,
    [Types.BUSCA_MENU_SUCESSO]: buscaMenuSucesso,
})
